export default __webpack_public_path__ + "static/media/facebook-white.7f03e7e6.svg";